/**
 * The behavior switch a NEW agent starts with (Segev, 2026-10-21).
 *
 * `config/default_behavior_switch.json` is its one source — the create route
 * and the Agent of Agents read the same file
 * (backend/modules/chatbots/services/default_behavior_switch.py). Labels and
 * descriptions follow the creator's UI language; instructions are for the
 * model and stay English.
 */
import source from '../../../../../config/default_behavior_switch.json';

export interface BehaviorSwitchConfig {
  enabled: boolean;
  title: string;
  description: string;
  default_index: number;
  modes: Array<{ label: string; description?: string; instruction: string }>;
}

export function defaultBehaviorSwitch(language: string): BehaviorSwitchConfig {
  const lang = language === 'he' ? 'he' : 'en';
  return {
    enabled: true,
    title: source.title[lang],
    description: source.description[lang],
    default_index: source.default_index,
    modes: source.modes.map((m) => ({
      label: m.label[lang],
      description: m.description[lang],
      instruction: m.instruction,
    })),
  };
}
